(() => {
  const SELECTOR = '[data-scroll-hero]';
  const instances = new WeakMap();
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

  const getStep = (progress) => {
    if (progress < 0.025) return 0;
    if (progress < 0.36) return 1;
    if (progress < 0.69) return 2;
    return 3;
  };

  const initialise = (hero) => {
    if (instances.has(hero)) return;

    const sticky = hero.querySelector('.home-hero__sticky');
    if (!sticky) return;

    let frame = 0;

    const update = () => {
      frame = 0;

      if (motionQuery.matches) {
        hero.dataset.heroStep = '3';
        hero.style.removeProperty('--hero-scroll-progress');
        return;
      }

      const heroRect = hero.getBoundingClientRect();
      const heroTop = window.scrollY + heroRect.top;
      const scrollDistance = Math.max(hero.offsetHeight - sticky.offsetHeight, 1);
      const progress = clamp((window.scrollY - heroTop) / scrollDistance, 0, 1);

      hero.dataset.heroStep = String(getStep(progress));
      hero.style.setProperty('--hero-scroll-progress', progress.toFixed(4));
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    const setMotionMode = () => {
      hero.classList.toggle('is-scroll-ready', !motionQuery.matches);
      requestUpdate();
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', setMotionMode);
    } else {
      motionQuery.addListener(setMotionMode);
    }

    instances.set(hero, () => {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);

      if (typeof motionQuery.removeEventListener === 'function') {
        motionQuery.removeEventListener('change', setMotionMode);
      } else {
        motionQuery.removeListener(setMotionMode);
      }

      if (frame) window.cancelAnimationFrame(frame);
      instances.delete(hero);
    });

    setMotionMode();
  };

  const initialiseWithin = (scope = document) => {
    if (scope.matches?.(SELECTOR)) initialise(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initialise);
  };

  initialiseWithin();

  document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const hero = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);

    instances.get(hero)?.();
  });
})();
